import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const notThis = ['Non è teoria copiata da un manuale.', 'Non è una raccolta disordinata di attività.', 'Non è materiale che devi riscrivere completamente.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-dark-card relative overflow-hidden" data-id="element-221" data-mp="1mqp5x7gv7kg6">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-222" data-mp="z1cwq7ljfcdv" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-223" data-mp="u3upcln6557z">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-224" data-mp="182klnz25z0va">
          <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-2xl mb-5" data-id="element-225" data-mp="2jfwwitwccjqy">
            🏆
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-226" data-mp="2bvpagfq4gayk">
            Il sistema completo di Metodologia della Ricerca pensato per l’aula
          </h2>
          <p className="text-xl font-bold text-gold-gradient mb-3 font-serif" data-id="element-227" data-mp="2gsz2820zgypk">
            Metodologia della Ricerca Pro
          </p>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-228" data-mp="2pv87acdhfzvk">
            6 volumi · 5 bonus strategici · Tutto pronto da usare da oggi.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left items-stretch" data-id="element-229" data-mp="1t3ee74pz3b9f">
          <motion.ul initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-dark-border" data-id="element-230" data-mp="1x72nbru96ews">
            {notThis.map(item => <li key={item} className="flex items-start gap-3" data-id="element-231" data-mp="1ef9tjv7d0po0">
                <XIcon className="text-red-500 shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-232" data-mp="2hr8rkw3jx2hb" />
                <span className="text-gray-400 text-sm" data-id="element-233" data-mp="2crvxbqacot4p">{item}</span>
              </li>)}
          </motion.ul>

          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 flex items-start gap-3" data-id="element-234" data-mp="2qldfb6ne1xsm">
            <CheckIcon className="text-gold shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-235" data-mp="27tb4wd1cbdqt" />
            <p className="text-white font-medium text-base leading-relaxed" data-id="element-236" data-mp="22w2p2j3nzlsq">
              È un sistema pensato per permetterti di entrare in aula con
              maggiore sicurezza e aiutare i tuoi studenti a imparare davvero a
              fare ricerca.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}